//import Vue from 'vue'
import Vuex from 'vuex';
import axios from 'axios';
import Loading from './modules/loading.js';
import CSFCLoading from './modules/CSFCloading.js';
import User from './modules/User.js';
import thirdParty from './plugins/thirdParty.js';
import Util from '../assets/js/util.js';

Vue.use(Vuex)
const modules =  {
    Loading,
    CSFCLoading,
    User
};
let ENV=Util.ENV();
const store = new Vuex.Store({
  plugins: [thirdParty],
  state: {
    userToken: '',
      //以上为刷新丢失数据
      //位置信息
    lat: window.localStorage.getItem('lat'),
    lng: window.localStorage.getItem('lng'),
    city: {
      code: window.localStorage.getItem('code'),
      name: window.localStorage.getItem('name'),
    },
    pointname: window.localStorage.getItem('pointname'),
    ha: {
      code: window.localStorage.getItem('hacode'),
      name: window.localStorage.getItem('haname'),
    },
      //
    selectCity : JSON.parse(window.localStorage.getItem('selectCity')),
     uid: Util.ENV()==3?'test003':'17781111111',
     pwd: '123456',
    jwtcode: window.localStorage.getItem('jwtcode'),
    APPUserToken: window.localStorage.getItem('APPUserToken'),
    channel: window.sessionStorage.getItem('channel'),//当前渠道（默认城市房产公众号）
    defaultChannel: 'cityhouse.mobile.gjh', //缺省渠道信息
    // 域名和channel对应关系
    hostChannelList: {
       'fcgj-bjls.cityhouse.cn'             : 'belugabh.mobile', //边界猎手
       'fcgj-bjls.cityre.cn'             : 'belugabh.mobile', //边界猎手
       'fcgj-creprice-ios.cityhouse.cn'     : 'creprice.mobile.ios', //中国房价行情iOS客户端
       'fcgj-creprice-ios.cityre.cn'     : 'creprice.mobile.ios', //中国房价行情iOS客户端
       'fcgj-creprice-android.cityhouse.cn' : 'creprice.mobile.android',  //中国房价行情Android客户端
       'fcgj-creprice-android.cityre.cn' : 'creprice.mobile.android',  //中国房价行情Android客户端
       'fcgj-cityhouse-ios.cityhouse.cn'    : 'cityhouse.mobile.ios',     //城市房产iOS客户端
       'fcgj-cityhouse-ios.cityre.cn'    : 'cityhouse.mobile.ios',     //城市房产iOS客户端
       'fcgj-cityhouse-android.cityhouse.cn': 'cityhouse.mobile.android',  //城市房产Android客户端
       'fcgj-cityhouse-android.cityre.cn': 'cityhouse.mobile.android',  //城市房产Android客户端
       'fcgj-ryx.cityhouse.cn'              : 'icbc.rong.e',         //融e行
       'fcgj-ryx.cityre.cn'              : 'icbc.rong.e',         //融e行
       'fcgj-wechat.cityre.cn'           : 'cityhouse.mobile.gjh', //微信公众号
       'fcgj-applet.cityhouse.cn'           : 'cityhouse.mobile.applet', //微信小程序
       'fcgj-applet.cityre.cn'           : 'cityhouse.mobile.applet', //微信小程序
       'wxcee5ef7fd0a853bc.cityre.cn': 'cityhouse.mobile.agent.gjh', //中介服务微信
       'wx6f36505c5388562f.cityre.cn': 'customer.gjh.63045c5dbe91227a', //金正评估微信
       'wx8733794bd1fac80d.cityhouse.cn': 'creprice.mobile.gjh', //中国房价行情微信公众号
       'wx8733794bd1fac80d.cityre.cn': 'creprice.mobile.gjh', //中国房价行情微信公众号
       'fcgj-grass.cityre.cn'            : 'grass.mobile.gjh',      //小草金管家
       'fcgj.cityre.cn'                  : 'icbc.rong.xt', //融e联（小贷、私人银行）
       //'fcgj-cmbc.cityhouse.cn'             : 'cmbc.mobile.app', //民生银行......
       'fcgj-cmb.cityre.cn'              : 'cmbchina.mobile.app', //招行
       //'fcgj-unionpay.cityhouse.cn'         : 'unionpay.mobile', //云闪付......
       //'fcgj-xinhuafinance.cityhouse.cn'    : 'xinhuanet.fortune.mobile', //新华财经......
       //'fcgj-qeb.cityhouse.cn'              : 'qeb.mobile', //青岛政务通......
       //'fcgj-hainas.cityhouse.cn'              : 'haina.mobile', //腾讯海纳渠道码......
       //'fcgj-msb.cityhouse.cn'              : 'msb.mobile', // 蒙速办渠道......
       'fcgj-icbc-mpd.cityhouse.cn'         : 'icbc.serv.mobile.applet',//工行个贷小程序
       'fcgj-icbc-mpd.cityre.cn'         : 'icbc.serv.mobile.applet',//工行个贷小程序
    },
    loginBack:["unionpay.mobile"],//登录后置的渠道
    channelList:{//渠道码字典
      'app': [ //app
          'belugabh.mobile',//边界猎手
        ],
      'userToken': [ // userToken 登录类型
          'creprice.mobile.ios', //中国房价行情iOS客户端
          'creprice.mobile.android', //中国房价行情Android客户端
          'cityhouse.mobile.ios',     //城市房产iOS客户端
          'cityhouse.mobile.android',  //城市房产Android客户端
      ],
      'server': [ //服务端登录的类型
          'icbc.rong.e',//融e行
          'cmbc.mobile.app', //民生银行
          'icbc.serv.mobile.applet',//工行个贷小程序
      ],
      'gjh': [ //公众号
        'cityhouse.mobile.gjh',//微信
        'cityhouse.mobile.applet',//微信小程序
        'cityhouse.mobile.agent.gjh',//中介服务
        'customer.gjh.63045c5dbe91227a', //金正评估微信
        'grass.mobile.gjh',//小草金管家
        'piglet.mobile.gjh',//猪年推广
      ],
      'rong':[ //融e工行与云闪付登录方式相同放在一块
        'icbc.rong.pb',//私人银行（工行）
        'icbc.rong.sl',//幸福AI家（工行）
        'icbc.rong.qd',//工行青岛分行（工行）
        'icbc.rong.xt',//禧泰房产管家（工行）
        'unionpay.mobile',//云闪付（银联）
      ],
      'other': [ //其他有自己 特殊登录渠道的
         'cmbchina.mobile.app', //招商银行渠道码
         'haina.mobile', //腾讯海纳渠道码
      ]
    },
    //通过微信第三方平台代公众号登录的渠道
    wechatThirdPlat:[
      'cityhouse.mobile.agent.gjh',
      'customer.gjh.63045c5dbe91227a',
      'creprice.mobile.gjh',
      'customer.gjh.1838bac1316b2cdc',
      'customer.gjh.1f236d12ab2c97cd',
      'customer.gjh.c1e97f8e2e1e79cf',
      'customer.gjh.774ac0845219f726',
      'customer.gjh.9bb1d2940425e1dd',
    ],
    //资源开关。 如果增加其他功能开关，需维护此选项。 如果功能是关闭状态，可以不写，现支持以下开关:
    //后退按钮开关 (showBack)、
    //广告 (advert) 格式如下:
    //[{
    //       src:require('@/assets/images/advert1.png'),
    //       href:"https://www.mszxyh.com/wapserver/outer/index.html?ChannelId=mszx02489&seq=DZZH_20181128138849&Page=index&_k=winwo9"
    //   },{
    //       src:require('@/assets/images/advert2.png'),
    //       href:"https://www.mszxyh.com/wapserver/apollo/index.html#/wapmain/ryb/rybProdIndex?ChannelId=mszx02489&seq=DZZH_20181128138849&Page=index&_k=gv4fy5"
    //   }
    // ]、
    //价格预警 (priceAlert)、
    //客服电话悬浮框（customTel）
    //行情走势（priceTrend）、
    //置换功能（substitute）、
    //统计(statistics): URL（统计需要引入的参数地址） |  false 、
    //发房源功能（release）
    //首页和导航（homePage）
    //房产优选功能 (selectHouse)
    //更多行情（moreTrend 暂时只限 融e联渠道）
    //首页展示快捷菜单（showIndexMenu）
    //首页价格块默认开启（showPriceBox）（1：新楼盘  2：二手房）
    // 贷款模块 （loanFlag）
    sourceSwitch: {
       'cityhouse.mobile.gjh' : {//微信公众号
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'selectHouse': true,
          'substitute': true,
          'release': true,
          'homePage': true,
          'showIndexMenu':true,
          'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=cityhouse&bankclient=1&purchase=1",
          'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
       },
        'cityhouse.mobile.applet' : {//微信小程序
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'selectHouse': true,
          'substitute': true,
          'release': true,
          'homePage': true,
          'showIndexMenu':true,
          'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=cityhouse&bankclient=1&purchase=1",
          'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
       },
        'customer.gjh.90f9e0fe66a4e98c' : {//城宜美
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'selectHouse': true,
            'substitute': true,
            'release': true,
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=cityhouse&bankclient=1&purchase=1",
            'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
        },
        'cityhouse.mobile.agent.gjh': {//微信中介服务公众号
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'selectHouse': true,
            'substitute': true,
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=agent&bankclient=1&purchase=1",
            'statistics': 'hm.baidu.com/hm.js?8a9aa9de73cbb1036799eb680f7b423b',
        },
        'customer.gjh.1838bac1316b2cdc': {//青岛福临万家二期东区
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'selectHouse': true,
            'substitute': true,
            'release': true,
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=agent&bankclient=1&purchase=1",
            'statistics': 'hm.baidu.com/hm.js?40f884a4b06462afa869bd70a87e7d20',
        },
        'customer.gjh.1f236d12ab2c97cd': {//青岛福临万家一期
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'selectHouse': true,
            'substitute': true,
            'release': true,
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=agent&bankclient=1&purchase=1",
            'statistics': 'hm.baidu.com/hm.js?40f884a4b06462afa869bd70a87e7d20',
        },
        'customer.gjh.c1e97f8e2e1e79cf': {//青岛福临万家二期西区
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'selectHouse': true,
            'substitute': true,
            'release': true,
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=agent&bankclient=1&purchase=1",
            'statistics': 'hm.baidu.com/hm.js?40f884a4b06462afa869bd70a87e7d20',
        },
        'customer.gjh.774ac0845219f726': {//今日宿城
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'selectHouse': true,
            'substitute': true,
            'release': true,
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=agent&bankclient=1&purchase=1",
            'statistics': 'hm.baidu.com/hm.js?40f884a4b06462afa869bd70a87e7d20',
        },'customer.gjh.9bb1d2940425e1dd': {//太平湾物业
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'selectHouse': true,
            'substitute': true,
            'release': true,
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=agent&bankclient=1&purchase=1",
            'statistics': 'hm.baidu.com/hm.js?40f884a4b06462afa869bd70a87e7d20',
        },
       'cityhouse.mobile.ios': {//城市房产app ios
          // 'priceAlert': true,
          // 'customTel': true,
          // 'priceTrend': true,
          // 'substitute': true,
          // 'release': true,
          //  'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
         'priceAlert': true,
         'customTel': true,
         'priceTrend': true,
         'selectHouse': true,
         'substitute': true,
         'release': true,
         'homePage': true,
         'showIndexMenu':true,
         'use_in_fcgj_app':true,
         'moreTrend': Util.ENV()==1?"https://hq-fcgj.creprice.cn/LocalIndex?channel=fcgj_app&purchase=1&bankclient=1":"https://hq-fcgj-test.creprice.cn/LocalIndex?channel=fcgj_app&purchase=1&bankclient=1",
         'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
       },
       'cityhouse.mobile.android': {//城市房产app 安卓
          // 'priceAlert': true,
          // 'customTel': true,
          // 'priceTrend': true,
          // 'substitute': true,
          // 'release': true,
          // 'moreTrend': Util.ENV()==1?"https://hq-fcgj.creprice.cn/LocalIndex?channel=fcgj_app&purchase=1&bankclient=1":"https://hq-fcgj-test.creprice.cn/LocalIndex?channel=fcgj_app&purchase=1&bankclient=1",
          //  'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
         'priceAlert': true,
         'customTel': true,
         'priceTrend': true,
         'selectHouse': true,
         'substitute': true,
         'release': true,
         'homePage': true,
         'showIndexMenu':true,
         'use_in_fcgj_app':true,
         'moreTrend': Util.ENV()==1?"https://hq-fcgj.creprice.cn/LocalIndex?channel=fcgj_app&purchase=1&bankclient=1":"https://hq-fcgj-test.creprice.cn/LocalIndex?channel=fcgj_app&purchase=1&bankclient=1",
         'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
       },
       'creprice.mobile.ios': {//房价行情app ios
          'priceAlert': false,
          'customTel': true,
          'priceTrend': true,
          'substitute': false,
           'selectHouse': true,
           'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
       },
       'creprice.mobile.android': {//房价行情app 安卓
          'priceAlert': false,
          'customTel': true,
          'priceTrend': true,
          'substitute': false,
           'selectHouse': true,
           'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
       },
       'cmbc.mobile.app': {//民生
          'priceAlert': false,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'selectHouse':true,
          'showIndexMenu':true,
          'release': true,
          'moreTrend': 'https://hq-fcgj.creprice.cn/LocalIndex?channel=cmbc&bankclient=1',
          'statistics': 'hm.baidu.com/hm.js?a497ed071e637e286946556f619e83bf',
       },
        'qeb.mobile': {//青岛政务通
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'substitute': true,
            'selectHouse':true,
            'showIndexMenu':false,
            'release': true,
            'moreTrend': 'https://hq-fcgj.creprice.cn/LocalIndex?channel=fcgj&bankclient=1',
            'statistics': 'hm.baidu.com/hm.js?62b4a80bc5a40bca74270bc1a439f811',
        },
       'cmbchina.mobile.app': {//招行
        'priceAlert': false,
        'customTel': true,
        'priceTrend': true,
        'substitute': true,
        'selectHouse':true,
        'showIndexMenu':true,
        'release': true,
        'moreTrend': 'https://hq-fcgj.creprice.cn/LocalIndex?channel=cmbchina&bankclient=1',
        'statistics': 'hm.baidu.com/hm.js?9f8d5b6ccce4cb741ddef0ddd69ae18e',
       },
        'unionpay.mobile': {//云闪付
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'substitute': true,
            'selectHouse':true,
            'showIndexMenu':false,
            'release': true,
            'moreTrend': '',
            'statistics': 'hm.baidu.com/hm.js?70711494b8fc4ed4f496249b6ea72503',
        },
        'xinhuanet.fortune.mobile': {//新华财经
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'substitute': true,
            'selectHouse':true,
            'showIndexMenu':false,
            'release': true,
            'moreTrend': 'https://hq-fcgj.creprice.cn/LocalIndex?channel=xhs&purchase=1',
            'statistics': 'hm.baidu.com/hm.js?f7e22e407a5dfd976f4e7b7f326cda12',
        },
       'icbc.rong.e': {//融e行
          'priceAlert': false,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'selectHouse':true,
          'showIndexMenu':true,
          'moreTrend': 'https://hq-ryx.creprice.cn/LocalIndex?channel=icbc&bankclient=1',
          'statistics': 'hm.baidu.com/hm.js?314dcb72397bf893019d692fddf0ea89',
       },
       'grass.mobile.gjh' : {//小草金管家
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'showIndexMenu':true,
          'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=fcgj&bankclient=1&showad=1",
           'statistics': 'hm.baidu.com/hm.js?aa9f5ff6288523ab161174220821df3c',
       },
       'customer.gjh.63045c5dbe91227a' : {//金正评估微信
            'priceAlert': true,
            'customTel': false,
            'priceTrend': true,
            'substitute': true,
            'selectHouse':true,
            'showIndexMenu':true,
            'release': true,
            'sysName': '金正智能估价',
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=jz",
            'statistics': 'hm.baidu.com/hm.js?ec8961de6ac930d3846d5409b9d76943',
       },
       'msb.mobile': {// 蒙速办渠道
          'loanFlag': true, //贷款模块
          'priceAlert': true,
          'customTel': false,
          'priceTrend': true,
          'substitute': true,
          'selectHouse':true,
          'showIndexMenu':false,
          'release': true,
          'sysName': '金正智能估价',
          'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=jz",
          'statistics': 'hm.baidu.com/hm.js?7a667efbfce7a1ad84ec603194268630',
        },
       'piglet.mobile.gjh': {
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
       },
       'icbc.rong.xt' : {//融e联
          'showBack': false,
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'selectHouse':true,
          'showIndexMenu':true,
          'moreTrend': "https://hq-ryl.creprice.cn/LocalIndex?channel=ryl&bankclient=1&purchase=1",
          'statistics': 'hm.baidu.com/hm.js?ad58dd0c74dc19eaff21dbb333e9c020',
       },
       'icbc.rong.pb': {
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'selectHouse':true,
          'showIndexMenu':true,
          'moreTrend': "https://hq-ryl.creprice.cn/LocalIndex?bankclient=1&purchase=1",
          'statistics': 'hm.baidu.com/hm.js?ad58dd0c74dc19eaff21dbb333e9c020',
       },
       'icbc.rong.sl': {
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'selectHouse':true,
          'showIndexMenu':true,
          'moreTrend': "https://hq-ryl.creprice.cn/LocalIndex?bankclient=1&purchase=1",
          'statistics': 'hm.baidu.com/hm.js?ad58dd0c74dc19eaff21dbb333e9c020',
       },
       'icbc.rong.qd': {
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'showIndexMenu':true,
          'moreTrend': "https://hq-ryl.creprice.cn/LocalIndex?bankclient=1",
          'statistics': 'hm.baidu.com/hm.js?ad58dd0c74dc19eaff21dbb333e9c020',
       },
       'belugabh.mobile': {//边界猎手
          'showBack': true,
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'showIndexMenu':true,
          'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=bjls&bankclient=1",
          'selectHouse': true,

       },
       'creprice.mobile.gjh': {//中国房价行情微信公众号
          'priceAlert': true,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'selectHouse':true,
          'release': true,
          'moreTrend': "https://wechat.creprice.cn/LocalIndex?channel=wechat&purchase=1",
          'statistics': 'hm.baidu.com/hm.js?c19cd3bbe83ed28dbc9203b9bf8007d6',
        },
        'icbc.serv.mobile.applet': {//工行个贷小程序
          'priceAlert': false,
          'customTel': true,
          'priceTrend': true,
          'substitute': true,
          'selectHouse':true,
          'showIndexMenu':true,
          'moreTrend': 'https://hq-ryx.creprice.cn/LocalIndex?channel=icbc&bankclient=1',
          'statistics': 'hm.baidu.com/hm.js?cbfdce5d836c80512b392a45e7ed6788',
        },
        'defaultwy': {//所有物业社区渠道第三发给登录默认defaultwy设置
            'priceAlert': true,
            'customTel': true,
            'priceTrend': true,
            'selectHouse': true,
            'substitute': true,
            'showPriceBox':2,
            'release': true,
            'moreTrend': "https://hq-fcgj.creprice.cn/LocalIndex?channel=agent&bankclient=1&purchase=1",
            'statistics': 'hm.baidu.com/hm.js?40f884a4b06462afa869bd70a87e7d20',
        },
    },
    openid: '123',
    apiLoadingList:[],
    selectData: '',

    propType: {
      11: '住宅',
      22: '商铺',
      21: '办公'
    },
    face: {
      1: '南向',
      10: '南北',
      2: '东向',
      3: '西向',
      4: '北向',
      5: '东南',
      6: '东北',
      7: '西南',
      8: '西北',
      9: '东西'
    },
    intDeco: {
      1: '毛坯房',
      2: '未装修',
      3: '局部装修',
      4: '简单装修',
      5: '精装修',
      6: '豪华装修'
    },
    indoStru: {
      11: '平层',
      12: '错层',
      13: '复式',
      14: '阁楼',
      18: '跃层'
    },
    bldgType: {
      11: '多层',
      12: '小高层',
      13: '高层',
      20: '平房',
      21: '别墅',
      22: '联体别墅'
    }//,
    //clearKeepAlive:{//以路由名命名 第一次进来默认为1 需要清理
    //    MyHouse:1,//资产列表
    //    AssessRecord:1//房产列表
    //}
  },
  getters: {
    getUrlParams: () => () => {
      var url = location.search;
      //var url = location.href;
      //    url=url.indexOf("?")!=-1?'?'+url.split('?')[1]:url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1), strs;
        strs = str.split('#')[0].split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    isChannel: (state, getters) => (type, search) => {
       var _arr = state.channelList[type];
       if (!_arr) {
         return false;
       }
       for(var i in _arr){
        if(_arr[i] == search){
          return true;
        }
       }
      return false;
    },
    // 获取功能开关：
    // return： mixed (source || true || false)
    getSourceSwitch: (state, getters) => (source) => {
       let _currentSource = state.sourceSwitch[getters.getChannel];
       //如果没有配置当前渠道，返回false
       if (!_currentSource) {
           if(window.sessionStorage.getItem('wx_isthirdpart')){//物业第三方平台登录
               _currentSource=state.sourceSwitch['defaultwy'];
           }else {
               return false;
           }
       }
       //如果当前渠道没有配置该选项 或者 配置了false，返回false
       if (!_currentSource[source]) {
         return false;
       }
       //返回当前选项的配置信息
       return _currentSource[source];
    },
    //统计PV页面
    statistics: (state, getters) => (path) => {
        if (process.env.NODE_ENV != 'production') return;
        if (!getters.getSourceSwitch('statistics')) return;
        if (!window._hmt) return;
        window._hmt.push(['_trackPageview', path]);
    },
    //统计事件
    trackEvent: (state, getters) => (category, action, opt_label) => {
        if (process.env.NODE_ENV != 'production') return;
        if (!getters.getSourceSwitch('statistics')) return;
        if (!window._hmt) return;
        let cityCode = getters.getSelectCity('code') || getters.getCity.code;
        let _category = `${cityCode}_${category}`;
        window._hmt.push(['_trackEvent', _category, action, opt_label]);
    },
    getValueById: (state, getters) => (type, id) => {
      return state[type][id]
    },
    getDetailArray: (state, getters) => (info, cutOff=false) => {
      var _array = [],
        _str1 = '';

      _array.push(getters.getValueById('propType', info.propType));
      if(info.bldgArea){
        _array.push(info.bldgArea + '㎡');
      }
      if (info.propType == 11){
        if (info.br > 0) _str1 += info.br + '室';
      }else{
        if (info.br > 0) _str1 += info.br + '间';
      }
      if (info.lr > 0) _str1 += info.lr + '厅';
      if (info.ba > 0) _str1 += info.ba + '卫';
      if (_str1) _array.push(_str1);

      if (info.bldgType && !cutOff) _array.push(getters.getValueById('bldgType', info.bldgType));
      if (info.floor && info.bheight)  _array.push(info.floor + '/' + info.bheight + '层');
      if (info.indoStru && !cutOff) _array.push(getters.getValueById('indoStru', info.indoStru))
      if (info.face && !cutOff) _array.push(getters.getValueById('face', info.face));
      if (info.intDeco && !cutOff) _array.push(getters.getValueById('intDeco', info.intDeco));
      if (info.buildYear && !cutOff ) _array.push(info.buildYear + '年');
      return _array;
    },
    getShareDetailArray: (state, getters) => (info) => {
      var _array = [],
        _str1 = '';

      _array.push(getters.getValueById('propType', info.propType));

      if (info.face) _array.push(getters.getValueById('face', info.face));
      if (info.intDeco) _array.push(getters.getValueById('intDeco', info.intDeco));
      if (info.bldgType) _array.push(getters.getValueById('bldgType', info.bldgType));
      if (info.buildYear) _array.push(info.buildYear + '年');
      return _array;
    },
    mixPrice: (state, getters) => (price, flag,type=null) => {
      if (!price) return 0;
      price = price * 1;
      var result, unit = '';
      var _price1 = getters.formatPrice(price);
      if(_price1.toString().indexOf('亿') != -1){
        unit = '亿';
      } else if(_price1.toString().indexOf('万') != -1){
        unit = '万';
      }
      var _price2 = _price1.toString().replace(unit, '') * 1;
      if(flag == 1){
        if (!unit) _price2 = Math.round(_price2);
      }else if(flag == 2){
        if (unit == '万') _price2 = Math.round(_price2);
      }
      if(_price2 >= 1000) {
        result = getters.thousandPrice(_price2);
      }else{
        result =  _price2;
      }
        //result+=unit;
        if(!type){
            return result+=unit;
        }else if(type==1){
            return result
        }else if(type==2){
            return unit
        }
        //console.log(unit)

    },
    splitMixPrice: (state, getters) => (price) => {
      if (!price) return 0;
      price = price * 1;
      var result, unit = '';
      var _price1 = getters.formatPrice(price);
      if (_price1.toString().indexOf('亿') != -1) {
        unit = '亿';
      } else if (_price1.toString().indexOf('万') != -1) {
        unit = '万';
      }
      var _price2 = _price1.toString().replace(unit, '') * 1;
      if (_price2 >= 1000) {
        result = getters.thousandPrice(_price2);
      } else {
        result = _price2;
      }
      return {value: result, unit: unit};
    },
    thousandPrice: (state, getters) => (price) => {
      if(!price) return 0;
      return price.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,');
    },
    formatPrice: (state, getters) => (price) =>{
      if (!price) return 0;
      price = price*1;
      if(price >= 10000*10000){
        return formatFour(price / 100000000) + '亿';
      }
      if(price >= 10000){
        return formatFour(price/10000) + '万';
      }else{
        return formatFour(price);
      }
      function formatFour(num){
        var price = num;
        if(num.toString().length > 4){
          if (num >= 100) {
            price = Math.round(num);
          } else if (num >= 10) {
            price =  Math.round(num * 10)/10;
          }else{
            price = Math.round(num * 100)/100;
          }
        }
        if (price.toString().length == 1){
          price = price.toString() + '.00';
        }else if(price.toString().length == 2){
          price = price.toString() + '.0';
        }else if(price.toString().length == 3){
          if(price < 10){
            price = price.toString() + '0';
          }
        }
        return price;
        return get_thousand_num(price);
      }
    },
    formatDate: (state, getters) => (month, dateRange) => {
      var date;
      dateRange = dateRange * 1;
      if (dateRange == 1) {
        var _date1 = month.split('-');
        _date1[1] = fillNum(_date1[1]);
        date = _date1.join('-') + '';
      } else {
        var _date = month.split('-'),
          _date2 = [];
        if ((_date[1] * 1 + 1) > dateRange * 1) {
          _date2[0] = _date[0];
          _date2[1] = _date[1] * 1 - dateRange + 1;
          _date2[1] = fillNum(_date2[1]);
        } else {
          _date2[0] = _date[0] * 1 - 1;
          _date2[1] = 12 + _date[1] * 1 + 1 - dateRange;
          _date2[1] = fillNum(_date2[1]);
        }
        _date[1] = fillNum(_date[1]);
        date = _date2.join('-') + '～' + _date.join('-') + '';
      }

      function fillNum(n) {
        if (n * 1 < 10) return '0' + n.toString();
        return n;
      }
      return date;
    },
    userToken: (state) => {
      return state.userToken;
    },
    getCity: (state) => {
      return state.city;
    },
    getCityName: (state) =>(citycode)=> {
        for(var i = 0; i < FcgjCityList.length; i++){
            for(var j = 0; j < FcgjCityList[i].children.length; j++){
                if(citycode == FcgjCityList[i].children[j].code){
                    return FcgjCityList[i].children[j].name;
                }
            }
        }
        return '';
    },
    getCityDist:(state,getters)=>(city)=>{
      for(var x in FcgjCityList){
          for(var xx in FcgjCityList[x]['children']){
              if(FcgjCityList[x]['children'][xx]['code']==city){
                  return FcgjCityList[x]['children'][xx]['children'];
              }
          }
      }
      return '';
    },
      getDist:(state,getters)=>(city,dist)=>{
          let dists=getters.getCityDist(city);
          for(var x in dists){
              if(dists[x].code==dist){
                  return dists[x];
              }
          }
          return '';
      },
    getRealChannel: (state, getters) => (isReal) => {
        // 0、优先读state的渠道信息
        if (state.channel) {
           return state.channel;
        }
        // 1、读取参数里面的渠道信息
        let _urlParam = getters.getUrlParams();
        if (_urlParam['state']) {
           return _urlParam['state'];
        }
        // 2、根据host匹配渠道信息
        let _host = location.host;
        let _channel = state.hostChannelList[_host];
        if (_channel) {
           return _channel;
        }
        // 3、如果以上都没有值，则返回空
        if (isReal) {
           return '';
        }

        return state.defaultChannel;
    },
    getChannel: (state, getters) => {
        return getters.getRealChannel(false);
    },
    getLat: (state) => {
      return state.lat;
    },
    getLng: (state) => {
      return state.lng;
    },
    getLocation: (state) => {
      if(state.lng && state.lat){
        return state.lng + ',' + state.lat;
      }else{
        return '';
      }
    },
    getPoint: (state) => {
        if(state.pointname &&state.lng && state.lat){
            return state.pointname+','+state.lng + ',' + state.lat;
        }else{
            return '';
        }
    },
    getSelectData: (state) =>{
      return state.selectData;
    },
    getBuildBaseInfo: (state, getters) => (data) =>{
      var str = '';
      if ( data.buildNo) {
        str = data.buildNo.replace(/号楼/g,'')+'号楼';
      }
      if ( data.unit) {
        str += data.unit.replace(/单元/g,'')+'单元';
      }
      if ( data.roomNo) {
        str += data.roomNo.replace(/室/g,'')+'室';
      }
      return str;
    },
    getSelectCity: (state,getters)=>(type)=>{
      if (!state.selectCity)
      return '';
      if (type)
      return state.selectCity[type]||'';
      return state.selectCity;
    }
  },
  mutations: {
    updateUserToken: (state, uToken) => {
      state.userToken = uToken;
      //window.localStorage.setItem('userToken', uToken);
    },
    updateJwtcode: (state, jwtcode) => {
      state.jwtcode = jwtcode;
      window.localStorage.setItem('jwtcode', jwtcode);
    },
    updateAPPUserToken: (state, userToken) => {
      state.APPUserToken = userToken;
      window.localStorage.setItem('APPUserToken', userToken);
    },
    updateChannel: (state, channel) => {
      state.channel = channel;
      window.sessionStorage.setItem('channel', channel);
    },
    updateOpenId: (state, openid) => {
      state.openid = openid;
    },
    updateApiLoadingList: (state, api) => {
      if(api>=0){
        state.apiLoadingList.push(api);
      }else if(state.apiLoadingList.length>0){
        state.apiLoadingList.splice(0,1);
      }
    },
    updateLocation: (state, options) => {
      state.pointname = options.pointname;
      state.lat = options.lat;
      state.lng = options.lng;
      window.localStorage.setItem('pointname', options.pointname);
      window.localStorage.setItem('lat', options.lat);
      window.localStorage.setItem('lng', options.lng);
    },
    updateCity: (state, options) =>{
          state.city={
              code: options.code,
              name: options.name
          }
          window.localStorage.setItem('code', options.code);
          window.localStorage.setItem('name', options.name);
    },
      updateHa: (state, options) =>{
          state.ha={
              code: options.code,
              name: options.name
          }
          window.localStorage.setItem('hacode', options.code);
          window.localStorage.setItem('haname', options.name);
      },
    updateCityList: (state, data) =>{
      state.cityList = data;
    },
    updateSelectData: (state, data) => {
      state.selectData = data;
    },
    updateSelectCity: (state, data) => {
      state.selectCity = data;
      window.localStorage.setItem('selectCity', JSON.stringify(data));
    },
    updateSourceSwitch: (state, {getters, source, val}) => {
      let channel = getters.getChannel;
      if(window.sessionStorage.getItem('wx_isthirdpart')){//物业第三方平台渠道
          channel='defaultwy';
      }
      state.sourceSwitch[channel][source] = val;
    },
  },
  actions: {
    updateSourceSwitch: ({commit, getters}, options) => {
      options.getters = getters;
      commit('updateSourceSwitch', options);
    },
    async updateUserToken({dispatch,commit}, token){
        commit('updateUserToken', token);
        await dispatch('updateUserInfo').then(() => {
            console.log('store更新用户信息...ok')
        });
          /*if(token){//登录成功后获取用户信息
              dispatch('updateUserInfo').then(() => {
                  //console.log('获取用户信息...')
              })
          }*/
    },
    updateJwtcode: ({commit}, jwtcode) =>{
      commit('updateJwtcode', jwtcode);
    },
    updateAPPUserToken: ({commit}, userToken) =>{
      commit('updateAPPUserToken', userToken);
    },
    updateOpenId: ({commit}, openId) =>{
      commit('updateOpenId', openId);
    },
    updateApiLoadingList: ({commit}, api) =>{
      commit('updateApiLoadingList', api);
    },
    updateChannel: ({commit}, channel) => {
      commit('updateChannel', channel);
    },
    updateLocation: ({commit}, options) =>{
      commit('updateLocation', options);
    },
    updateCity: ({commit}, options) => {
      commit('updateCity', options);
    },
    updateSelectData: ({commit}, options) => {
      commit('updateSelectData', options);
    },
    updateSelectCity: ({commit}, data) => {
      commit('updateSelectCity', data);
    },
  },
  modules: modules
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js